import { Component } from "vue-property-decorator";
import { mapActions, mapGetters, mapMutations } from "vuex";
import baseUserContextComponent from "./baseUserContextComponent";
import { UserLoggedInfoModel } from "@/models/userModels";

@Component({
	methods: {
		...mapMutations(["setWindowSize", "setUser"]),
		...mapActions(["logoutUser"])
	}
})
export default class topNavBar extends baseUserContextComponent {
	setUser!: (user: UserLoggedInfoModel | null) => void;
	updateUserInfo!: () => Promise<UserLoggedInfoModel>;
	logoutUser!: () => Promise<boolean>;
	doLogout() {
		this.logoutUser().finally(() => this.$router.push({ name: "login" }));
	}
	beforeDestroy() {}
	beforeMount() {
		var instance = this;
	}
	mounted() {}
	beforeCreate() {}
	created() {
		var instance = this;
	}
}
